import { render, staticRenderFns } from "./SelectArchi.vue?vue&type=template&id=3dd48ba2&scoped=true"
import script from "./SelectArchi.vue?vue&type=script&lang=js"
export * from "./SelectArchi.vue?vue&type=script&lang=js"
import style0 from "./SelectArchi.vue?vue&type=style&index=0&id=3dd48ba2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd48ba2",
  null
  
)

export default component.exports